export class WebsocketMsg<T = any, D = any> {
  type: T;
  data: D;

  constructor(msg) {
    this.type = msg.type;
    this.data = msg.data;
  }
}
